/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputVideoCaptionInfo
 */
export interface InputVideoCaptionInfo {
    /**
     * 
     * @type {string}
     * @memberof InputVideoCaptionInfo
     */
    captionText: string;
    /**
     * 
     * @type {string}
     * @memberof InputVideoCaptionInfo
     */
    captionLanguageCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof InputVideoCaptionInfo
     */
    isAutoGen: boolean;
    /**
     * 
     * @type {string}
     * @memberof InputVideoCaptionInfo
     */
    url: string;
}

/**
 * Check if a given object implements the InputVideoCaptionInfo interface.
 */
export function instanceOfInputVideoCaptionInfo(value: object): value is InputVideoCaptionInfo {
    if (!('captionText' in value) || value['captionText'] === undefined) return false;
    if (!('captionLanguageCode' in value) || value['captionLanguageCode'] === undefined) return false;
    if (!('isAutoGen' in value) || value['isAutoGen'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function InputVideoCaptionInfoFromJSON(json: any): InputVideoCaptionInfo {
    return InputVideoCaptionInfoFromJSONTyped(json, false);
}

export function InputVideoCaptionInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputVideoCaptionInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'captionText': json['caption_text'],
        'captionLanguageCode': json['caption_language_code'],
        'isAutoGen': json['is_auto_gen'],
        'url': json['url'],
    };
}

export function InputVideoCaptionInfoToJSON(json: any): InputVideoCaptionInfo {
    return InputVideoCaptionInfoToJSONTyped(json, false);
}

export function InputVideoCaptionInfoToJSONTyped(value?: InputVideoCaptionInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'caption_text': value['captionText'],
        'caption_language_code': value['captionLanguageCode'],
        'is_auto_gen': value['isAutoGen'],
        'url': value['url'],
    };
}

